import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '明星爆料', path: '/category/celebrity' },
  { label: '网红黑料', path: '/category/influencer' },
  { label: '社会热点', path: '/category/society' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link
            to="/"
            className="flex items-center gap-2.5 group cursor-pointer"
          >
            <span className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? 'bg-primary-500' : 'bg-white/20 backdrop-blur-sm'
            }`}>
              <i className={`ri-leaf-fill text-lg md:text-xl ${
                scrolled || !isHome ? 'text-background-50' : 'text-white'
              }`}></i>
            </span>
            <span className={`text-lg md:text-xl font-heading font-bold tracking-tight whitespace-nowrap transition-colors ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}>
              51黑料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-10">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium tracking-wide whitespace-nowrap transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? scrolled || !isHome ? 'text-primary-500' : 'text-white font-semibold'
                    : scrolled || !isHome ? 'text-foreground-700 hover:text-foreground-950' : 'text-white/80 hover:text-white'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled || !isHome ? 'text-foreground-600 hover:text-foreground-950' : 'text-white/70 hover:text-white'
              }`}
            >
              关于我们
            </Link>
            <button
              type="button"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-all cursor-pointer ${
                scrolled || !isHome
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/20 text-white hover:bg-white/30 backdrop-blur-sm'
              }`}
              aria-label="订阅推送"
            >
              <i className="ri-arrow-right-up-line text-sm"></i>
            </button>
          </div>

          <button
            type="button"
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`py-2.5 px-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === item.path
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="border-t border-background-200/70 pt-3 mt-1">
              <Link
                to="/about"
                className="block py-2.5 px-3 rounded-lg text-sm font-medium text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
              <button
                type="button"
                className="mt-2 w-full py-2.5 px-3 rounded-lg text-sm font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
              >
                订阅推送 <i className="ri-arrow-right-up-line ml-1"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}